// extracted by mini-css-extract-plugin
export default {"navitems":"Navbar_navitems__1cxh9","navbardiv":"Navbar_navbardiv__JSHey"};